<template>
<div id="">
  <v-container fluid class="pt-0 ">
    <v-row>
      <v-col cols="12" class="pt-0 ">
        <v-card style="min-height:85vh" class="admin_secondary">
          <v-card-title class="secondary white--text">
            Contests
            <v-spacer></v-spacer>

            <v-btn icon dark @click="load" :loading="loading">
              <v-icon>fa-sync</v-icon>
            </v-btn>
          </v-card-title>
          <v-container class=" white--text">
            <v-row align="center">

              <v-col cols="12" md="4" lg="3" xl="2">
                <v-text-field v-model="search" append-icon="fa-search" dark label="Search" outlined hide-details clearable></v-text-field>
              </v-col>

              <v-col cols="12" md="4" lg="3" xl="2">
                <v-select outlined hide-details clearable dark label="Status" placeholder="All" :items="filters" v-model="filter"></v-select>
              </v-col>
            </v-row>
            <v-data-table :loading="loading" :headers="headers" :items="contestsList" :search="search">

              <template v-slot:item.account.business="{ item }">
                <router-link  :to="`/admin/business?search=${item.account.business}`">{{item.account.business}}</router-link>
                </template>

                <template v-slot:item.id="{ item }">
                  <router-link  :to="`/admin/contests/${item.id}`">{{item.id}}</router-link>
                  </template>

              <template v-slot:item.title="{ item }">
                <router-link  :to="`/admin/contests/${item.id}`">{{item.title}}</router-link>
                </template>

                <template v-slot:item.title="{ item }">
                  <router-link  :to="`/admin/contests/${item.id}`">{{item.title ? item.title : `${item.brand_name} ${item.prize}`}}</router-link>
                  </template>

              <template v-slot:item.status="{ item }">
                    <span :class="`${item.status === 0 ?  'blue' : item.status===1 ? 'green' : item.status===2 ? 'red' : 'grey'}--text`">
                        {{item.status === 0 ?  'Pending' : item.status===1 ? 'Open' : item.status===2 ? 'Closed' : 'Completed'}}
                        </span>
                </template>


              <template v-slot:item.deadline="{ item }">
                    {{item.deadline | dateFormat}}
              </template>

              <template v-slot:item.entries="{ item }">
                  <router-link :to="`/admin/projects/contests?contest_id=${item.id}`">{{item.entries}}</router-link>
              </template>

            </v-data-table>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</div>
</template>
<script>
import headersSimple from "./headers_simple.json"


export default {
  name: "",
  components: {

  },
  data: () => ({
    search: '',
    filters: ["Pending", "Open", "Closed"],
    filter: null,
    loading: false,
    contests: []
  }),
  computed: {
    headers() {
      return headersSimple
    },
    contestsList() {
      return this.contests.filter(function(contest) {
        if (this.filter) {
          let status = contest.status === 0 ? "Pending" : contest.status === 1 ? "Open" : "Closed"
          return status === this.filter
        } else {
          return true;
        }

      }.bind(this)).map(function(contest) {

        contest.entries = contest.projects.length

        contest.entries_unfiltered = contest.projects.filter(p => {
          return p.status === 2
        }).length

        contest.entries_eligible = contest.projects.filter(p => {
          return p.status >= 3 && p.status <= 11
        }).length

        contest.entries_rejected = contest.projects.filter(p => {
          return p.status === 13
        }).length


        return contest;
      }.bind(this))
    },
    accountsList() {
      return this.accounts.filter(a => {
        return a.type === 'business'
      }).map(function(a) {


        return a;
      }.bind(this))
    }
  },
  methods: {
    async load() {
      this.loading = true
      await Promise.all([this.loadContests()])
      this.loading = false
    },
    async loadContests() {
      this.contests = await this.$api(`/account/admin/contests`)
    }
  },
  created() {
    this.load()
  }
}
</script>
<style lang="scss" scoped>
</style>
